/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { createFieldSchema, } from "../schemaTypes.js";
export function createFieldSchemaUnsafe(kind, allowedTypes, props) {
    // At runtime, we still want this to be a FieldSchema instance, but we can't satisfy its extends clause, so just return it as an FieldSchemaUnsafe
    return createFieldSchema(kind, allowedTypes, props);
}
//# sourceMappingURL=schemaFactoryRecursive.js.map